import { Component } from 'react';

import { VoidInterface } from 'types/functions';
import { twclsx } from 'utils/twclsx';
import Image from './Image';

interface ButtonProps {
    name?: string;
    className?: string;
    children?: string | JSX.Element | JSX.Element[];
    onClick?: VoidInterface;
    disabled?: boolean;
    loading?: boolean;
    type?: 'submit' | 'reset' | 'button' | undefined;
}

interface ButtonState {
    loading: boolean;
}

class Button extends Component<ButtonProps, ButtonState> {
    constructor(props: ButtonProps) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    static getDerivedStateFromProps(props: ButtonProps, state: ButtonState) {
        if (props.loading !== state.loading) {
            return {
                loading: props.loading,
            };
        }
        return null;
    }

    render() {
        // eslint-disable-next-line react/prop-types
        const { className, children, disabled, loading, onClick, name, type } = this.props;

        return (
            <button
                type={disabled || loading ? 'button' : type || 'button'}
                onClick={() => {
                    if (disabled || loading) {
                        return;
                    }

                    if (onClick) {
                        onClick();
                    }
                }}
                className={twclsx(
                    'inline-flex',
                    'items-center',
                    'justify-center',
                    'py-2.5',
                    'px-3.5',
                    'rounded-lg',
                    'font-medium',
                    'transition-all',
                    className,
                    disabled && 'bg-gray-400'
                )}
                name={name}
            >
                {this.state.loading && (
                    <Image alt="loading" className="w-3 m-auto mr-2" src="/static/images/loading.svg"></Image>
                )}{' '}
                {children}
            </button>
        );
    }
}

export default Button;
